import { AxiosInstance } from "./client";
import { ProductApis } from "./endpoints";

export const getProducts = (params) => {
  return AxiosInstance()
    .get(ProductApis.LIST_PRODUCTS, { params })
    .then((response) => response?.data?.data);
};

export const getVariants = (params) => {
  return AxiosInstance()
    .get(ProductApis.LIST_VARIANTS, { params })
    .then((response) => response?.data?.data);
};
